export default "__VITE_ASSET__Di_WyNX2__"